import moment from 'moment'

import { withDefaultAgeRestrictedSetting } from '../helpers'

const initialState: InitialDataObjectiveBased = {
  goal: 'reach',
  products: [],
  name: null,
  daily_budget: null,
  start_at: moment().format('YYYY-MM-DD'),
  end_at: '',
  is_always_on: true,
  settings: withDefaultAgeRestrictedSetting()
}

export default initialState
